import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Box, Text, Flex, Card } from '@resideo/blueprint-react';
import { useTranslation } from 'react-i18next';
import NeutralIcon from 'components/icons/password-neutral.svg?react';
import SuccessIcon from 'components/icons/password-yes.svg?react';

const StyledIcon = css`
  height: 21px;
`;

const StyledSuccessIcon = styled(SuccessIcon)`
  fill: #258039;
  ${StyledIcon}
`;

const StyledNeutralIcon = styled(NeutralIcon)`
  fill: transparent;
  ${StyledIcon}
`;

const PasswordCard = styled(Card)`
  background: #f2f2f2 0 0 no-repeat padding-box;
  border-radius: 11px;
`;

interface ValidatorItemProps {
  label: string;
  status: boolean;
}

const ValidatorItem: FC<ValidatorItemProps> = ({ label, status }) => (
  <Flex>
    {status ? <StyledSuccessIcon /> : <StyledNeutralIcon />}
    <Text marginLeft='small' color={status ? 'faded' : 'text'}>
      {label}
    </Text>
  </Flex>
);

interface PasswordValidatorProps {
  lowercase: boolean;
  uppercase: boolean;
  number: boolean;
  symbol: boolean;
  length: boolean;
}

export const PasswordValidator: FC<PasswordValidatorProps> = ({
  lowercase,
  uppercase,
  number,
  symbol,
  length,
}) => {
  const { t } = useTranslation();

  return (
    <Box flex={1} marginBottom='medium'>
      <PasswordCard>
        <Box padding='medium'>
          <Text marginBottom='xSmall'>
            {t('signUp.validation.passwordMust')}
          </Text>
          <ValidatorItem
            label={t('signUp.validation.passwordRules.length')}
            status={length}
          />
          <ValidatorItem
            label={t('signUp.validation.passwordRules.lowercase')}
            status={lowercase}
          />
          <ValidatorItem
            label={t('signUp.validation.passwordRules.uppercase')}
            status={uppercase}
          />
          <ValidatorItem
            label={t('signUp.validation.passwordRules.numberOrSymbol')}
            status={number || symbol}
          />
        </Box>
      </PasswordCard>
    </Box>
  );
};
